import { useLocation } from 'react-router-dom';
import NotificationActionLayout, { NotificationActionLayoutType } from "../../components/NotificationActionLayout/NotificationActionLayout";
import ApproveAmendmentAction from "./ApproveAmendmentAction";
import ApproveInvoiceAction from "./ApproveInvoiceAction";
import { notificationSomethingWentWrongContent } from "./NotificationAction.utils";
import { NotificationActionType } from "./NotificationActionTypes";
import ApproveTeamMemberInvitation from "./ApproveTeamMemberInvitation";
import { jsx as _jsx } from "react/jsx-runtime";
const NotificationActionPage = () => {
  const {
    state
  } = useLocation();
  if (!state) {
    return /*#__PURE__*/_jsx(NotificationActionLayout, {
      state: {
        type: NotificationActionLayoutType.AfterAction,
        afterAction: notificationSomethingWentWrongContent
      }
    });
  }
  function renderActionComponent(state) {
    switch (state.type) {
      case NotificationActionType.ApproveAmendment:
        return /*#__PURE__*/_jsx(ApproveAmendmentAction, {
          token: state.token,
          vendorName: state.vendorName
        });
      case NotificationActionType.ApproveInvoice:
        return /*#__PURE__*/_jsx(ApproveInvoiceAction, {
          vendorName: state.vendorName,
          token: state.token,
          invoiceFormattedNumber: state.invoiceFormattedNumber,
          invoiceFormattedAmount: state.invoiceFormattedAmount
        });
      case NotificationActionType.ApproveTeamMemberInvitation:
        return /*#__PURE__*/_jsx(ApproveTeamMemberInvitation, {
          invitingUserName: state.invitingUserName,
          invitingUserEmail: state.invitingUserEmail,
          invitingBusinessName: state.invitingBusinessName,
          invitingBusinessId: state.invitingBusinessId,
          invitationId: state.invitationId
        });
    }
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "notification-action-page",
    children: renderActionComponent(state)
  });
};
export default NotificationActionPage;